<template>
    <div class="file-input-component" :class="{'disabled': disabled}">
        <div class="photo-frame">
            <div class="preview-container" v-if="imageType">
                <img :src="image" />
            </div>
            <label class="file-input-container" :class="[emptyClass]">
                <input
                    type="file"
                    v-on:change="onImageChange"
                    ref="file-input"
                    class="file-upload-input"
                    :disabled="disabled"
                />
            </label>
        </div>
        <slot name="delete" :mark-deleted="doMarkDeleted" v-if="showDeleteButton">
            <button class="file-delete-button" @click="doMarkDeleted(true)">Delete</button>
        </slot>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        srcImage: String,
        disabled: Boolean,
        imageType: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            content: null,
            markDeleted: false,
        };
    },
    watch: {
        value(val) {
            console.log(val);
            if (val == null) {
                this.reset();
            }
        },
    },
    methods: {
        onImageChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
            this.doMarkDeleted(false);
        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                this.content = e.target.result;
                this.$emit("input", this.content);
            };
            reader.readAsDataURL(file);
        },
        clearFile() {
            if (this.$refs["file-input"]) {
                this.$refs["file-input"].value = "";
            }
        },
        doMarkDeleted(state) {
            this.markDeleted = state;
            this.$emit("mark-deleted", this.markDeleted);
            if (state) {
                this.content = null;
                this.$emit("input", null);
                this.clearFile();
            }
        },
        reset() {
            this.markDeleted = false;
            this.content = null;
            this.clearFile();
        },
    },
    computed: {
        image() {
            return this.content || this.value || this.srcImage;
        },
        emptyClass() {
            if (!this.image || this.markDeleted) {
                return "empty";
            }
        },
        showDeleteButton() {
            return !this.markDeleted && this.image && !this.disabled;
        },
    },
};
</script>

<style lang="scss">
.preview-container {
    margin-bottom: 10px;
}
</style>
